/* eslint-disable jsx-a11y/anchor-is-valid */
import { OrderedListOutlined, UserOutlined } from '@ant-design/icons';
import {  Menu } from 'antd';
import dayjs from 'dayjs';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileContext from 'services/profileContext';
import styles from 'styles/components/sidebar.module.scss';
import UpgradeButton from './upgradeButton';
import { isAdmin } from 'utils/utils';
import pluralize from 'pluralize';

const Sidebar = () => {
  const location = window.location.hash.substring(2); // Remove '/#' from start
  const defaultSelected = location || 'cycles';
  const { profile } = useContext(ProfileContext);
  const navigate = useNavigate();
  const menuItems = [
    {
      key: 'cycles',
      label: 'All Cycles',
      icon: <OrderedListOutlined />,
    },
    {
      key: 'users',
      label: 'All Users',
      icon: <UserOutlined />,
    },
  ];
  const onClick = (e) => {
    navigate(`/${e.key}`);
  };

  const getCurrentPlan = () => {
    if (profile.workspace?.buddiesSubscription) {
      return 'Paid plan';
    } else if (profile.workspace?.freeTrialStartDate) {
      return 'Free trial';
    } else {
      return 'Free plan';
    }
  };

  const isCurrentlyInFreeTrial = () => {
    return (
      profile.workspace?.freeTrialStartDate &&
      !profile.workspace?.buddiesSubscription &&
      profile.workspace?.freeTrialEndDate &&
      dayjs(profile.workspace?.freeTrialEndDate).isAfter(dayjs())
    );
  };

  const isFreeTrialExpired = () => {
    return (
      profile.workspace?.freeTrialStartDate &&
      !profile.workspace?.buddiesSubscription &&
      profile.workspace?.freeTrialEndDate &&
      dayjs(profile.workspace?.freeTrialEndDate).isBefore(dayjs())
    );
  };

  const isFreePlan = () => {
    return (
      !profile.workspace?.buddiesSubscription &&
      !profile.workspace?.freeTrialStartDate
    );
  };

  // const hasSubscription = () => {
  //   return profile.workspace?.buddiesSubscription;
  // };

  return (
    <div className={styles.sidebar}>
      <Menu
        onClick={onClick}
        defaultSelectedKeys={[defaultSelected]}
        mode="inline"
        items={menuItems}
        className={styles.menu}
      />
      {profile && isAdmin(profile) && (
        <div className={styles.currentPlan}>
          Current plan: {getCurrentPlan()}
          {isFreePlan() && (
            <div style={{ marginTop: 4 }}>
              {!profile.workspace?.slack && (
                <div>{profile.workspace?.seats} {pluralize('seat', profile.workspace?.seats)} used</div>
              )}
            </div>
          )}
          {isCurrentlyInFreeTrial() && (
            <div style={{ marginTop: 4 }}>
              <b>
                {dayjs(profile.workspace?.freeTrialEndDate).diff(
                  dayjs(),
                  'day'
                )}{' '}
                {pluralize('day', dayjs(profile.workspace?.freeTrialEndDate).diff(dayjs(), 'day'))} remaining
              </b>
              {!profile.workspace?.slack && (
                <div>{profile.workspace?.seats} {pluralize('seat', profile.workspace?.seats)} used</div>
              )}
              <div style={{ marginTop: 4 }}>
                <UpgradeButton block style={{ marginTop: 4 }} />
              </div>
            </div>
          )}
          {isFreeTrialExpired() && (
            <div style={{ marginTop: 4 }}>
              <b>Free trial expired</b>
              {!profile.workspace?.slack && (
                <div>{profile.workspace?.seats} {pluralize('seat', profile.workspace?.seats)} used</div>
              )}
              <div style={{ marginTop: 4 }}>
                <UpgradeButton block style={{ marginTop: 4 }} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
